import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-user-interested',
  templateUrl: './user-interested.component.html',
  styleUrls: ['./user-interested.component.css']
})
export class UserInterestedComponent implements OnInit {
  interested: any = {};
  categories: any;
  userId = this.userService.getUid();
  user: any;
  private subscription: Subscription = new Subscription();
  isLoading = true;
  constructor(
    private afs: AngularFirestore,
    private dialog: MatDialog, private userService: UserService) {
    this.subscription.add(this.afs.collection('categories', ref => ref.where('parent', '==', false)).valueChanges().subscribe(data => {
      this.categories = data;
      this.isLoading = false;
    }));
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
      this.interested = user.interestedCategories ? user.interestedCategories : {};
    }));

  }

  onSubmit(f) {
    this.afs.collection('users').doc(this.userId).update({ interestedCategories: this.interested }).then(() => {
      this.getPoint();
    });
  }

  getPoint() {
    const interestedCat = this.user.interestedCategories;
    const userInfoPoints = this.user.userInfoPoints;
    const my_Obj = Object.values(interestedCat).filter(ctrl => { return ctrl; });
    const point = 50;

    if (userInfoPoints.interested === 0 && my_Obj.length > 0) {
      this.afs.collection('users').doc(this.userId).update({
        userInfoPoints: {
          interested: point
        }
      }).then(() => {
        this.afs.collection('users').doc(this.userId).update({
          point: {
            totalPoint: (this.user.point.totalPoint || 0) + point
          }
        });
      })
    } else if (my_Obj.length === 0 && userInfoPoints.interested === point) {
      this.afs.collection('users').doc(this.userId).update({
        userInfoPoints: {
          interested: 0
        }
      }).then(() => {
        this.afs.collection('users').doc(this.userId).update({
          point: {
            totalPoint: this.user.point.totalPoint - point
          }
        });
      });
    }

    if (my_Obj.length > 0) {
      if (userInfoPoints.interested == 0) {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: point + " puan kazanarak " + (this.user.point.totalPoint + point) + " puana yükseldin.",
            type: "update"
          }
        });
      } else {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Değişiklikler kaydedildi.",
            type: "update"
          }
        });
      }
    } else {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: point + " puan kaybederek " + (this.user.point.totalPoint - point) + " puana düştün.",
          type: "update"
        }
      });
    }


  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/user-interested/user-interested.component.ts